import React, { useEffect, useState } from 'react';
import {
  batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';
import { DateTime } from 'luxon';

import { ReactComponent as IconFilter } from '../../../../assets/icon/ic_filter.svg';
import ButtonTypes from '../../../../constants/buttonTypes';
import Text from '../../../../components/Text/Text';
import CustomSelect from '../../../../components/Select/CustomSelect';
import { orderedPartsStatusList } from '../../../../constants/orderedPartsStatus';
import CustomDatePicker from '../../../../components/CustomDatePicker/CustomDatePicker';
import Button from '../../../../components/Button/Button';
import {
  setOrderedPartsFilter
} from '../../../../actions/coilovers/orderedParts/orderedPartsFilter';
import getOrderedParts from '../../../../thunks/coilovers/orderedParts/getOrderedParts';
import CustomDropdownMenu from '../../../../components/CustomDropdownMenu/CustomDropdownMenu';
import { IconReload } from '../../../../assets/icon';
import { orderedTypesList } from '../../../../constants/orderedTypes';

const selectContainerClassName = 'max-w-[300px] first:mb-[20px]';
const labelContainerClassName = 'mb-[6px]';
const labelTextClassName = 'text-[13px]';
const buttonClassName = 'mr-[10px]';

const OrderedPartsRightHeader = () => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [partStatusSelected, setPartStatusSelected] = useState([]);
  const [orderedTypeSelected, setOrderedTypeSelected] = useState([]);
  const [menuVisible, setMenuVisible] = useState(false);

  const {
    orderedPartsFilter: {
      partStatus,
      orderedType,
    },
  } = useSelector((state) => ({
    orderedPartsFilter: state?.orderedPartsFilter,
  }), shallowEqual);

  useEffect(() => {
    if (partStatus) {
      setPartStatusSelected(partStatus.map((item) => (
        { label: item, value: item }
      )));
    }
    if (orderedType) {
      setOrderedTypeSelected(orderedType.map((item) => (
        { label: item, value: item }
      )));
    }
  }, [partStatus, orderedType]);

  const onReset = (withSearch) => {
    setStartDate();
    setEndDate();
    setPartStatusSelected([]);
    setOrderedTypeSelected([]);
    batch(() => {
      dispatch(setOrderedPartsFilter({
        partStatus: false, orderDateFrom: false, orderDateTo: false, page: 1, orderedType: false
      }));
    });
    if (withSearch) {
      dispatch(getOrderedParts());
    }
  };

  const onApply = () => {
    const partStatusValue = partStatusSelected.map(({ value }) => value);
    const orderedTypeValue = orderedTypeSelected.map(({ value }) => value);
    const orderDateFrom = startDate ? DateTime.fromISO(startDate?.toISOString()).toFormat('yyyy-MM-dd') : '';
    const orderDateTo = endDate ? DateTime.fromISO(endDate?.toISOString()).toFormat('yyyy-MM-dd') : '';
    setMenuVisible(false);
    batch(() => {
      dispatch(setOrderedPartsFilter({
        ...(partStatusSelected && { partStatus: partStatusValue }),
        ...(orderedTypeSelected && { orderedType: orderedTypeValue }),
        ...(startDate && { orderDateFrom }),
        ...(endDate && { orderDateTo }),
        page: 1
      }));
      dispatch(getOrderedParts());
    });
  };

  return (
    <div className="flex flex-row items-center">
      {(!!startDate || !!endDate || !!partStatusSelected.length || !!orderedTypeSelected.length) && (
        <Button
          icon={<IconReload />}
          type={ButtonTypes.LIGHT}
          onClick={() => onReset(true)}
          tooltipId="resetFilter"
          tooltip="Reset filter"
        />
      )}
      <CustomDropdownMenu
        Icon={IconFilter}
        btnText="Filter"
        btnType={ButtonTypes.LIGHT_PRIMARY}
        headerText="Filter Options"
        show={menuVisible}
        onToggle={setMenuVisible}
        indicator={!!startDate || !!endDate || !!partStatusSelected.length || !!orderedTypeSelected.length}
      >
        <div className={selectContainerClassName}>
          <Text text="Part status:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <CustomSelect
            value={partStatusSelected}
            options={orderedPartsStatusList}
            isClearable
            isMulti
            onChange={setPartStatusSelected}
          />
        </div>
        <div className={selectContainerClassName}>
          <Text text="Orderd type:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <CustomSelect
            value={orderedTypeSelected}
            options={orderedTypesList}
            isClearable
            isMulti
            onChange={setOrderedTypeSelected}
          />
        </div>
        <br />
        <div className={selectContainerClassName}>
          <Text text="Order date:" styleContainer={labelContainerClassName} textStyle={labelTextClassName} />
          <CustomDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            maxDate={new Date()}
          />
        </div>
        <br />
        <div className="flex flex-row justify-end">
          <div className="flex flex-row">
            <Button
              text="Reset"
              type={ButtonTypes.LIGHT}
              containerStyle={buttonClassName}
              onClick={onReset}
            />
            <Button text="Apply" onClick={onApply} />
          </div>
        </div>
      </CustomDropdownMenu>
    </div>
  );
};

OrderedPartsRightHeader.propTypes = {};

OrderedPartsRightHeader.defaultProps = {};

export default OrderedPartsRightHeader;
